module.exports = __webpack_public_path__ + "img/wallpaper_second.4eda67bd.png";